import { useFormContext, type FieldValues } from 'react-hook-form';

import { Field, CheckBox } from '@ctct/ui-react';

import { useFormLoadingContext } from './FormLoadingContext';
import { errorAdapter } from './helpers';
import type { PropsBase } from './types';

type Props<T extends FieldValues> = PropsBase<T>;

export function FormFieldCheckbox<T extends FieldValues>({
  label,
  name,
  qeId,
  optional,
  disableMarginBottom,
}: Props<T>) {
  const id = `form-field-${name}`;
  const isLoading = useFormLoadingContext();

  const {
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<T>();

  const error = errors[name];
  const value = watch(name);

  return (
    <Field
      data-qe-id={qeId}
      label=""
      labelFor={id}
      error={errorAdapter(error)}
      category={optional ? 'optional' : undefined}
      style={{ marginBottom: disableMarginBottom ? 0 : undefined }}
    >
      {isLoading ? null : (
        <CheckBox
          id={id}
          name={name}
          data-qe-id={qeId.concat('-checkbox')}
          error={!!error}
          text={label}
          onChange={(e) =>
            setValue(name, e.target.checked, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
          }
          checked={value}
        />
      )}
    </Field>
  );
}
